// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
// axios包装类
import axios from 'axios'
// 兼容ios10+ 的浏览器， URLSearchParams 会报错
import 'url-search-params-polyfill'
// 相关初始化样式、图标字体
import './common/stylus/index.styl'
// iView 框架
import iView from 'view-design'
import 'view-design/dist/styles/iview.css'
// 系统常量
import Const from './utils/CaseManagerConst.js'
import { i18n } from '@/utils/lang'
Vue.use(iView)
Vue.use(Const)
/*   *************************************** axios start ********************************* */
axios.interceptors.request.use(
  config => {
    if (localStorage.JWT_TOKEN) { // 如果存在token，则添加到请求头中
      config.headers.Authorization = localStorage.getItem('JWT_TOKEN')
    }
    // 超时等待2.5秒
    // config.timeout = 2500
    // 每个请求添加前缀
    config.baseURL = '/case/'
    // 检查config.data的类型
    if (config.data instanceof FormData) {
      // 处理FormData类型的请求
      config.data.append('laboratoryId', localStorage.getItem('laboratoryId'))
      let userId = 'userId' + localStorage.getItem('userName')
      if (localStorage.getItem(userId) !== null) {
        config.data.append('userId', localStorage.getItem(userId))
      }
    } else {
      // 处理非FormData类型的请求
      let data = new URLSearchParams(config.data)
      data.append('laboratoryId', localStorage.getItem('laboratoryId'))
      let userId = 'userId' + localStorage.getItem('userName')
      if (localStorage.getItem(userId) !== null) {
        data.append('userId', localStorage.getItem(userId))
      }
      config.data = data
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)
axios.interceptors.response.use(
  response => {
    return response
  },
  error => {
    if (error.response) {
      switch (error.response.status) {
        // 如果状态为401未授权，则清楚登陆token，返回登陆页
        case 401:

          break
        // 如果状态为302（手动退出），则清楚登陆token，返回登陆页
        case 302:

          break
        // 如果状态为500（服务器抛出错误），则清楚登陆token，返回登陆页
        case 500:
          // 服务器抛出错误，返回500页面

          break
      }
    }
    return Promise.reject(error.response.data)
  }
)
// 绑定axios属性
Vue.prototype.$http = axios
/* *************************************** axios end **************************************** */
Vue.config.productionTip = false

// 跳转校验
router.beforeResolve((to, from, next) => {
  // 设置标题
  window.document.title = to.meta.title
  // 如果未匹配到路由，就匹配上级路由
  if (to.matched.length === 0) {
    // 如果上级也未匹配到路由则跳转首页
    from.name ? next({ name: from.name }) : next({ name: 'Index' })
  } else {
    // 如果匹配到正确跳转
    next()
  }
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js